<template>
  <div>
    <div class="item-product-card d-flex my-2">
      <v-img :src="image"
             width="120" class="item-product-card-image px-2">
        <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0 img-loader h"
          align="center"
          justify="center"
          style="height: 100%;"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
      </v-img>
      <div class="d-flex flex-column ml-3">
        <h4 class="item-product-card-title">{{ commercialNameTranslated }}</h4>
        <div class="d-flex my-2">
          <counter-block
            @add="addQty"
            @subtract="subtractQty"
            :counter="qty"
            small
          />
        </div>
        <div class="d-flex justify-space-between">
          <h4 class="bold">{{ unit_price }} $</h4>
          <v-btn @click="toggleCommentBox" icon x-small><v-icon color="black" small>fas fa-edit</v-icon></v-btn>
        </div>
      </div>
    </div>
    <div v-if="showCommentBox">
      <div class="mb-2">{{ shopCartCommentLabelTitle }}</div>
      <v-textarea
        no-resize
        rows="2"
        outlined
        placeholder="e.g. less spices"
        v-model="actualComment"
      ></v-textarea>
      <div class="box-save-btn">
        <v-btn
          class="order-btn"
          color="black"
          :style="textBtnStyle"
          small
          @click="saveComment"
        >{{ shopCartTextCommentBtnSaveTitle }}</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  MultiLanguageText, TextProps
} from '../models';
import CounterBlock from './CounterBlock.vue';

export default {
  name: 'product-cart-item-block',
  components: { CounterBlock },
  props: {
    commercialName: { type: Object, required: true, default: () => null },
    qty: { type: Number, required: true, default: () => null },
    image: { type: String },
    unit_price: { type: Number, required: true, default: () => 0 },
    comment: { type: String },
    bannerShopCartCommentLabel: { type: Object, required: true, default: () => ({}) },
    bannerShopCartTextCommentBtnSave: { type: Object, required: true, default: () => ({}) },
    bannerShopTextProps: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      showCommentBox: false,
      actualComment: ''
    };
  },
  methods: {
    addQty() {
      this.$emit('addQty');
    },
    subtractQty() {
      this.$emit('subtractQty');
    },
    toggleCommentBox() {
      this.showCommentBox = !this.showCommentBox;
    },
    saveComment() {
      this.$emit('saveComment', { comment: this.actualComment });
      this.toggleCommentBox();
    }
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    myCommercialName() {
      return new MultiLanguageText(this.commercialName);
    },
    commercialNameTranslated() {
      return this.myCommercialName.getText(this.selectedLanguage);
    },
    myBannerShopCartCommentLabel() {
      return new MultiLanguageText(this.bannerShopCartCommentLabel);
    },
    shopCartCommentLabelTitle() {
      return this.myBannerShopCartCommentLabel.getText(this.selectedLanguage);
    },
    myBannerShopCartTextCommentBtnSave() {
      return new MultiLanguageText(this.bannerShopCartTextCommentBtnSave);
    },
    shopCartTextCommentBtnSaveTitle() {
      return this.myBannerShopCartTextCommentBtnSave.getText(this.selectedLanguage);
    },
    myShopTextProps() {
      return new TextProps(this.bannerShopTextProps);
    },
    textBtnStyle() {
      return this.myShopTextProps.getStyles();
    },
  },
  watch: {
    comment: {
      immediate: true,
      handler(newValue) {
        this.actualComment = newValue;
      }
    }
  }
};
</script>
<style>
.item-product-card-image {
  border-radius: 15px;
  text-align: center;
}
.box-save-btn {
  width: 100%;
}

.img-loader {
  background: rgba(0,0,0,0.3);
}
</style>
